import {
  hasCourseStarted,
  type CourseProgressStateLike,
} from './courseProgressState';

export interface CourseAssignmentStateLike extends CourseProgressStateLike {
  is_assigned?: boolean | null;
}

/**
 * A school student's course that was assigned, started, then revoked
 * (`is_assigned === false`) stays visible but locked ("paused") so the student
 * can see it was revoked but can no longer work on it.
 */
export function isCoursePaused(
  course: CourseAssignmentStateLike | null | undefined,
): boolean {
  return course?.is_assigned === false && hasCourseStarted(course);
}

/**
 * Whether a user-course should appear in the course list for the current viewer.
 *
 * - Assigned courses (or legacy records without the flag) are always visible.
 * - A revoked course (`is_assigned === false`) is hidden, EXCEPT for a school
 *   student who already started it — that one is shown in a paused/locked state
 *   (see {@link isCoursePaused}).
 */
export function isUserCourseVisible(
  course: CourseAssignmentStateLike | null | undefined,
  options: { isSchoolStudent: boolean },
): boolean {
  if (course?.is_assigned !== false) return true;
  if (!options.isSchoolStudent) return false;
  return hasCourseStarted(course);
}
